export default __webpack_public_path__ + "static/media/image-sample-selfie.c76f8ce5.png";